import Button from 'components/Button'
import Drawer from 'components/Drawer'
import ScheduleinterviewIcon from 'components/icons/ScheduleInterviewIcon'
import {
  ButtonDiv,
  FileInfoDiv,
  ResultDiv,
  ResultIconDiv,
  UploadMsgFlex,
} from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/ScheduledSuccessfully/style'
import React from 'react'
import { toCamelCase } from '../../../../../utils/camelCase'

const ScheduledInterview = ({
  setPrivew,
  interviewInfo,
  success,
  clearAll,
  setSuccess,
  setNotification,
  setCreateSlotDrawer,
  setCandidateInfo,
  selectedRoundType,
}) => {
  const content = () => {
    const typeLabels = {
      ASSESMENT: 'Assessment',
      GROUP: 'Group Discussion',
      FACE_TO_FACE: 'Interview',
      EXTERNAL_ASSESMENT: 'Assessment',
    }
    const labelText = typeLabels[selectedRoundType?.type] || ''
    const messageType = toCamelCase(labelText)

    return (
      <UploadMsgFlex column center centerVertically>
        <ResultIconDiv>
          <ScheduleinterviewIcon />
        </ResultIconDiv>
        <ResultDiv>{messageType} Scheduled Successfully</ResultDiv>
        <FileInfoDiv>
          Time and dates for the {interviewInfo?.roundName} has been shared with
          the candidates successfully
        </FileInfoDiv>

        <ButtonDiv>
          <Button.Secondary
            text="Close"
            width="80px"
            height="36px"
            onClick={() => {
              setSuccess(false)
              setPrivew(false)
              setCreateSlotDrawer(false)
              setNotification(false)
              setCandidateInfo(false)
            }}
          />
        </ButtonDiv>
      </UploadMsgFlex>
    )
  }

  return (
    <Drawer
      width="43%"
      title={'Confirm'}
      placement="right"
      visible={success}
      content={content()}
      onClose={clearAll}
      closable
    />
  )
}

export default ScheduledInterview
